import React, { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest, msalConfig } from "./AuthConfig";
import { InteractionStatus } from "@azure/msal-browser";

export default function Login() {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    // ユーザーログイン（リダイレクトモード）
    useEffect(() => {
        console.log("ユーザーログイン（リダイレクトモード）");
        console.log(isAuthenticated);
        console.log(inProgress);

        if (!isAuthenticated && inProgress === InteractionStatus.None) {
            if (!localStorage.getItem("isSessionTimeout")) {
                localStorage.clear();
            }

            console.log("loginRedirect");
            instance.loginRedirect(loginRequest);
            instance.handleRedirectPromise()
                .then()
                .catch((error) => {
                    console.log(error);
                    if (error.errorMessage) {
                        if (error.errorMessage.indexOf("AADB2C90118") > -1) {
                            forgotPassword();
                        }
                    }
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [instance, inProgress, isAuthenticated]);

    async function forgotPassword() {
        const request = {
            scopes: ["openid", ...msalConfig.b2cScopes],
            authority: process.env.REACT_APP_FORGOTPASSWORD_AUTH,
            redirectUri: process.env.LOGIN_RETURN_URL,
        };
        await instance.loginRedirect(request);
    }

    return <></>;
}
